// Service Worker Registration for offline support and sync

// Register the service worker
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/empty-service-worker.js`;
      
      registerValidSW(swUrl);
      
      // Set up online/offline status handling
      handleOnlineStatus();
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('Service Worker registered successfully');
      
      // Check for updates
      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing;
        
        installingWorker.addEventListener('statechange', () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content is available; notify user
              console.log('New content is available; please refresh.');
              
              // Dispatch event for the app to handle
              document.dispatchEvent(
                new CustomEvent('sw-update-available', { 
                  detail: { registration } 
                })
              );
            } else {
              // Content is cached for offline use
              console.log('Content is cached for offline use.');
              
              // Dispatch event for the app to handle
              document.dispatchEvent(
                new CustomEvent('sw-cached', { 
                  detail: { registration } 
                })
              );
            }
          }
        });
      });
      
      // Set up message event listener
      navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

// Handle messages from Service Worker
function handleServiceWorkerMessage(event) {
  console.log('Received message from service worker:', event.data);
  
  if (event.data && event.data.type === 'SYNC_COMPLETE') {
    // Show notification to user that sync is complete
    const count = event.data.count || 0;
    if (count > 0) {
      // Notify the app that data has been synced
      document.dispatchEvent(
        new CustomEvent('data-synced', { 
          detail: { count } 
        })
      );
    }
  }
}

// Set up online/offline event listeners - simplified
function handleOnlineStatus() {
  const updateOnlineStatus = () => {
    const isOnline = navigator.onLine;
    
    // Dispatch custom events for the app to handle
    document.dispatchEvent(
      new CustomEvent(isOnline ? 'app-online' : 'app-offline')
    );
    
    // If we're coming back online, just notify the app
    if (isOnline) {
      console.log('[Online Status] Application is back online');
    } else {
      console.log('[Online Status] Application is offline');
    }
  };
  
  // Set up event listeners
  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
  
  // Initial check
  updateOnlineStatus();
}

// Process any pending mutations
export function processPendingMutations() {
  if (!('serviceWorker' in navigator) || !navigator.serviceWorker.controller) {
    console.log('Service Worker not available, skipping pending mutations');
    return Promise.resolve({ success: false, error: 'Service Worker not available' });
  }
  
  return new Promise((resolve, reject) => {
    const messageChannel = new MessageChannel();
    
    messageChannel.port1.onmessage = (event) => {
      if (event.data.error) {
        reject(new Error(event.data.error));
      } else {
        resolve(event.data);
      }
    };
    
    try {
      navigator.serviceWorker.controller.postMessage(
        { type: 'PROCESS_PENDING_MUTATIONS' },
        [messageChannel.port2]
      );
    } catch (error) {
      console.error('Error sending message to service worker:', error);
      reject(error);
    }
  });
}

// Clear API cache
export function clearApiCache() {
  if (!('serviceWorker' in navigator) || !navigator.serviceWorker.controller) {
    return Promise.reject(new Error('Service Worker not available'));
  }
  
  return new Promise((resolve, reject) => {
    const messageChannel = new MessageChannel();
    
    messageChannel.port1.onmessage = (event) => {
      if (event.data.error) {
        reject(new Error(event.data.error));
      } else {
        resolve(event.data);
      }
    };
    
    navigator.serviceWorker.controller.postMessage(
      { type: 'CLEAR_API_CACHE' },
      [messageChannel.port2]
    );
  });
}

// Unregister service worker
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Export utility functions
export default {
  register,
  unregister,
  processPendingMutations,
  clearApiCache
};